import { useCallback, useState } from 'react';
import { sdk } from 'sdk';

interface IntercomResponse {
  ticketId?: string;
  error?: string;
  isError?: boolean;
  data?: any;
}

const useIntercomTicket = () => {
  const [loading, setLoading] = useState(false);

  const createTicket = useCallback(
    async (ticketData: any) => {
      setLoading(true);

      try {
        const res = (await sdk.callAction({
          actionName: 'intercom/createTicket',
          payload: ticketData,
        })) as IntercomResponse;

        if (res?.isError) {
          return { error: res.error || 'Unknown error occurred', isError: true };
        }

        return res;
      } catch (e) {
        return { error: 'Failed to connect to support service', isError: true };
      } finally {
        setLoading(false);
      }
    },
    [sdk],
  );

  const getTicketMapping = useCallback(
    async (ticketTypeId: string) => {
      setLoading(true);
      try {
        const res = await sdk.callAction({
          actionName: 'intercom/getTicketMapping',
          payload: { ticketTypeId: ticketTypeId },
        });

        if (res?.isError) {
          return { error: res.error || 'Failed to fetch mapping', isError: true };
        }

        return res;
      } catch (e) {
        return { error: 'Failed to connect to mapping service', isError: true };
      } finally {
        setLoading(false);
      }
    },
    [sdk],
  );

  const getRegionalTicketIds = useCallback(
    async () => {
      setLoading(true);

      try {
        const res = (await sdk.callAction({
          actionName: 'intercom/getRegionalTicketIds',
        })) as IntercomResponse;

        if (res?.isError) {
          return { error: res.error || 'Unknown error occurred', isError: true };
        }

        return res;
      } catch (e) {
        return { error: 'Failed to connect to support service', isError: true };
      } finally {
        setLoading(false);
      }
    },
    [sdk],
  );

  return { createTicket, getTicketMapping, getRegionalTicketIds, loading };
};

export default useIntercomTicket;
